// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3pO_C","content":"GlobalSearch_content__3Y3rH"};